module.exports = __webpack_public_path__ + "static/media/FILES.f8c4b306.gif";